skrilla.controller('productFeeReportsCtrl', function ($scope, $q, searchService, cacheService, srefService, modalService) {
    $scope.feeKey = "productFeeReports";
    $scope.feeReports = cacheService.getObjectOrElse("productFeeReportsTable", []);

    $scope.selectedFeeReports = [];
    $scope.selectedIntegrityReports = [];

    $scope.testModal = function(){
        modalService.openModal("views/productFeeReports/createTestReportModal.html", true, 'lg', true, true);
    }

    function clickRow(report, event){
        srefService.go("reportDetails", {id: report.id}, event);
    }

    $scope.tableData = {
        columns: [
            {title: "Name", field: "name"},
            {title: "Interval", field: "interval"},
            {title: "Is Test", field: "isTest"},
            {title: "Is Recalclulation", field: "isRecalculation"},
            {title: "Notes", field: "masterNote"},
            {title: "Calculation From", field: "calculationStartAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Calculation To", field: "calculationEndAt", filter:{name: 'dateTimeFormatter'}},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}}
        ],
        rows: {orderBy: "-createdAt", onClick: clickRow},
        isSkrillaTable: true,
        data: $scope.feeReports
    }


    $scope.bulkExport = function(type){
        let reports = type === "fee" ? $scope.selectedFeeReports : $scope.selectedIntegrityReports;
        cacheService.registerObject("productReportsBulkExportData", {type: type, reports: reports});
        modalService.openModal("views/downloadProductReportsModal/downloadProductReportsModal.html", true, 'lg', true, true);
    }

    $scope.click = function(){
        console.log($scope.tableData);
    }
});

